<template>
  <div class="modal-bg" v-show="show" @mousemove="modalMove" @mouseup="cancelMove">
    <div class="modal-container">
      <div class="modal-header" @mousedown="setStartingPoint">
        {{ title }}
      </div>
      <div class="modal-main">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <button  @click="hideModal">{{$t('header.close')}}</button>
<!--        <el-button type="primary" round @click="submit">确认</el-button>-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        x: 0,
        y: 0,
        node: null,
        isCanMove: false
      }
    },
    mounted() {
      this.node = document.querySelector('.modal-container')
    },
    methods: {
      hideModal() {
        this.$emit('hideModal')
      },

      submit() {
        this.$emit('submit')
      },

      setStartingPoint(e) {
        this.x = e.clientX - this.node.offsetLeft
        this.y = e.clientY - this.node.offsetTop
        this.isCanMove = true
      },

      modalMove(e) {
        if (this.isCanMove) {
          this.node.style.left = e.clientX - this.x + 'px'
          this.node.style.top = e.clientY - this.y + 'px'
        }
      },

      cancelMove() {
        this.isCanMove = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .modal-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.4);
    z-index: 10000;
  }
  .modal-container {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .modal-header {
    background: #145a82;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
    border-bottom: 1px solid #575757;

  }
  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    height:3vw;
    border-top: 1px solid #ddd;
  }
  .modal-footer button {
    width: 10vw;
    border: none;
    width: 100%;
    background: #fff;
  }
  .modal-main {
    padding: 1.5vw 2vw;
  }
  @media only screen and (min-width: 800px) {
    .modal-header {
      height:3.5vw;
    }
    .modal-footer {
      height:2.8vw;
    }
    .modal-footer button {

      height: 2.5vw;
    }
  }
  @media only screen and (max-width: 800px) {
    .modal-container {
      width: 90%;
    }
    .modal-header {
      height:8vw;
      font-size: 2.5em;
    }
    .modal-footer {
      height:7vw;
      font-size: 2.5em;
    }
    .modal-footer button {
      height: 5vw;
    }
    .modal-main{
      p{
        font-size: 1.8em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/News/Modal.vue